// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, OnInit } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'coa-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss'],
})
export class DescriptionComponent implements OnInit {

  titles: string[];

  ngOnInit(): void {
    const titles = ['of fashion', 'of cosmetics', 'of jewelry', 'of automotive'];
    this.titles = titles.map(value => marker(value));
  }

}
